

import { filterXSS } from 'xss'
import { config } from "../config";
import { getFileServerFileByFileIdApi } from "../api/fileServer";

export function uniqueById(objects) {
  // id'leri bir Set içine ekleyerek tekilleştirme
  const uniqueObjects = Array.from(new Set(objects.map(obj => obj.id)))
    .map(id => objects.find(obj => obj.id === id));

  return uniqueObjects;
}

export const monthDiff = (d1, d2) => {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

export const getImageArchiveImageUrl = (imageArchive) => {
  return config.apiUrl + "/imageArchive/" + imageArchive.inst + "/" + imageArchive.uuid + "." + imageArchive.ext
}

export const getFileServerImageUrl = (fileServer) => {
  return config.apiUrl + fileServer.filePath + fileServer.coverPhotoFileId + fileServer.ext
}

export const getImageArchiveImageWebUrl = (imageArchive) => {
  return config.apiUrl + "/imageArchive/" + imageArchive.inst + "/web/" + imageArchive.uuid + ".jpg"
}
export const getFileServerImageWebUrl = async (fileId) => {


  const { data } = await getFileServerFileByFileIdApi(fileId);
  let file = data;
  return config.apiUrl + file.filePath + file.id + file.ext;
}


export const getVideoArchiveVideoWebUrl = (videoObj) => {
  return config.apiUrl + "/videoArchive/" + videoObj.inst + "/web/" + videoObj.uuid + ".gif"
}

export const getVideoArchiveVideoUrl = (videoObj) => {
  return config.apiUrl + "/videoArchive/" + videoObj.inst + "/" + videoObj.uuid + "." + videoObj.ext
}



export const urlParams = (url, name) => {
  // eslint-disable-next-line
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
  if (results == null) {
    return null;
  }
  else {
    return decodeURI(results[1]) || 0;
  }
}


export function filterXSSHtmlTag(object) {



  Object.entries(object).forEach(([key, value]) => {
    // //console.log(`${key}:${value}`)

    if (typeof value == "string")
      object[key] = filterXSS(value, {
        whiteList: [], // empty, means filter out all tags
        stripIgnoreTag: true, // filter out all HTML not in the whilelist
        stripIgnoreTagBody: ["script"] // the script tag is a special case, we need
        // to filter out its content
      });
  })


  return object;

}

export function toDate(dateStr) {
  //21.04.1990
  var parts = dateStr.split(".")
  var newDate = new Date(parts[2], parts[1] - 1, parts[0])
  // //console.log("new date ", newDate.toLocaleDateString() );
  return newDate;
}


export function formatDate(date1) {
  let date = new Date(date1);
  const monthNames = config.mounth;
  // //console.log("object  date",date);
  const day = date.getDay();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return day + ' ' + monthNames[monthIndex] + ' ' + year;
}

export function countWord(s) {
  s = s.replace(/(^\s*)|(\s*$)/gi, "");
  s = s.replace(/[ ]{2,}/gi, " ");
  s = s.replace(/\n /, "\n");
  return s.split(' ').length;
}

export function formatDateTextFieldDate(date) {

  function appendLeadingZeroes(n) {
    if (n <= 9) {
      return "0" + n;
    }
    return n
  }

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return year + '-' + appendLeadingZeroes(month) + '-' + appendLeadingZeroes(day);


}

export function convertMiliseconds(miliseconds, format) {
  var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

  total_seconds = parseInt(Math.floor(miliseconds / 1000));
  total_minutes = parseInt(Math.floor(total_seconds / 60));
  total_hours = parseInt(Math.floor(total_minutes / 60));
  days = parseInt(Math.floor(total_hours / 24));

  seconds = parseInt(total_seconds % 60);
  minutes = parseInt(total_minutes % 60);
  hours = parseInt(total_hours % 24);

  switch (format) {
    case 's':
      return total_seconds;
    case 'm':
      return total_minutes;
    case 'h':
      return total_hours;
    case 'd':
      return days;
    default:
      return { d: days, h: hours, m: minutes, s: seconds };
  }
};

export const isRoleAndAppViewCheck = (appId, userRoles, userInst) => {
  switch (appId) {
    case 1: //ABSİS
      return userRoles.some(item => (item.id === 1) || (item.id > 9 && item.id < 14));
    case 2: //INSIS
      return userRoles.some(item => (item.id === 1) || (item.id > 9 && item.id < 14));
    case 3: //PEK
      return userRoles.some(item => (item.id === 1) || (item.id === 80) || (item.id === 81));
    case 4: //DAVA
      return userRoles.some(item => (item.id === 1) || (item.id === 6));
    case 5: //EDS //henüz boş 
      return false
    case 6: //YBS 
      return userRoles.some(item => (item.id === 1) || (item.id === 60));
    case 7: //YONSIS
      return userRoles.some(item => (item.id === 1) || (item.id > 69 && item.id < 74));
    case 13: //YAYSIS YONETIM
      return userRoles.some(item => (item.id === 1) || (item.id > 49 && item.id < 55));
    case 16: //YAYSIS
      return userRoles.some(item => (item.id === 1) || (item.id > 54 && item.id < 58));
    case 17: //EDSIS YONETIM - dESTEK TAKIP GOREVLISI
      return userRoles.some(item => (item.id === 1) || (item.id === 41));
    case 18://EDSIS YONETIM - KURUM KOORDINATOR
      return userRoles.some(item => (item.id === 1) || (item.id === 42));
    case 19://EDSIS YONETIM - YUKSEK KURUM KOORDINATOR
      return userRoles.some(item => (item.id === 1) || (item.id === 45));
    case 20://EDSIS YONETIM - TAKVIM GOREVLISI
      return userRoles.some(item => (item.id === 1) || (item.id === 43));
    case 23: //EDSIS BAŞVURU 
      return userRoles.some(item => (item.id === 1) || (item.id === 40));
    case 24: //EDSIS KURUMICI BASVURU
      return userRoles.some(item => (item.id === 1) || (item.id === 44));
    case 25: //PROSIS
      return userRoles.some(item => (item.id === 1) || (item.id === 20));
    case 26: //PROSIS YONETIM - MODERATOR
      return userRoles.some(item => (item.id === 1) || (item.id === 21));
    case 27: //PROSIS YONETIM - PROJE TAKIP GÖREVLISI
      return userRoles.some(item => (item.id === 1) || (item.id === 22));
    case 28: //PROSIS YONETIM - KURUM KOORDINATORU
      return userRoles.some(item => (item.id === 1) || (item.id === 23));
    case 29: //PROSIS YONETIM - PDK UYESI
      return userRoles.some(item => (item.id === 1) || (item.id === 24));
    case 31: //PROSIS YONETIM - YK KOORDINATORU
      return userRoles.some(item => (item.id === 1) || (item.id === 25));
    case 32: //BURSIS YONETIM - LİSANÜSTÜ
      return userRoles.some(item => (item.id === 1) || (item.id === 31) || (item.id === 32) || (item.id === 33));
    case 33: //BURSIS YONETIM - LİSANS
      return userRoles.some(item => (item.id === 1) || (item.id === 31) || (item.id === 34) || (item.id === 33));
    case 34: // AKM - EMAGAZA
      return userRoles.some(item => (item.id === 1) || (item.id === 5 && userInst === "AKM") || (item.id === 5 && userInst === "YK"));
    case 35: // ATAM - EMAGAZA
      return userRoles.some(item => (item.id === 1) || (item.id === 5 && userInst === "ATAM") || (item.id === 5 && userInst === "YK"));
    case 37: // TDK - EMAGAZA
      return userRoles.some(item => (item.id === 1) || (item.id === 5 && userInst === "TDK") || (item.id === 5 && userInst === "YK"));
    case 38: // TTK - EMAGAZA
      return userRoles.some(item => (item.id === 1) || (item.id === 5 && userInst === "TTK") || (item.id === 5 && userInst === "YK"));
    case 39: // BILSIS - YENI
      return userRoles.some(item => (item.id === 1) || (item.id === 82));
    default:
      return false;

  }
};



export function getFullName(user) {
  if (user.name.charAt(user.name.length - 1) === ' ') {
    return user.title !== "" ? user.title + ' ' + user.name + user.surname : user.name + user.surname
  }
  else {
    return user.title !== "" ? user.title + ' ' + user.name + ' ' + user.surname : user.name + ' ' + user.surname
  }
}

export const isRoleCheck = (roles, roleId) => {
  return roles.find(x => x.id === roleId) !== undefined
}

export function formatDateYYYYMMDD(date1) {
  let date = new Date(date1);
  const year = date.getFullYear();

  return year + "-" + date.toLocaleDateString("tr", { month: '2-digit' }) + '-' + date.toLocaleDateString("tr", { day: '2-digit' });
}

export const userInst = (inst) => {
  if (inst === "YK") {
    return "Atatürk Kültür, Dil ve Tarih Yüksek Kurumu"
  }
  else if (inst === "TTK") {
    return "Türk Tarih Kurumu Başkanlığı"
  }
  else if (inst === "TDK") {
    return "Türk Dil Kurumu Başkanlığı"
  }
  else if (inst === "AKM") {
    return "Atatürk Kültür Merkezi Başkanlığı"
  }
  else if (inst === "ATAM") {
    return "Atatürk Araştırma Merkezi Başkanlığı"
  }
  return inst

}


export const getAuthorizedInsts = (userRoles) => {
  const isSuperAdmin = userRoles.some(x => x.id === 1);
  if (isSuperAdmin) {
    return config.institutions.map(x => x.value);
  }

  const bookArchiveRole = userRoles.filter(x => x.id === 76);
  if (bookArchiveRole && bookArchiveRole.length > 0) {
    return bookArchiveRole.map(role => role.inst);
  }
  return [];
};

export const getOrderStatusProps = (status) => {
  switch (status) {
    case "Ödeme Başarılı":
      return {
        label: status,
        color: "#07bc0c" // success
      };
    case "İptal Edildi":
      return {
        label: status,
        color: "#e74c3c" // danger
      };
    case "Sipariş Alındı":
      return {
        label: status,
        color: "#bb86fc"
      };
    case "Kargoya Verildi":
      return {
        label: status,
        color: "#f1c40f"
      };
    case "Ödeme Bekliyor":
      return {
        label: status,
        color: "#f39711" // warning
      };
    case "İşlem Başladı":
      return {
        label: status,
        color: "#3498db" // info
      };
    case "İşlem Tamamlandı":
      return {
        label: status,
        color: "#4caf50"
      };
    case "İşlem Reddedildi":
      return {
        label: status,
        color: "#ff2d55" // danger
      };
    case "Ödeme Hatası: Host Bağlantı Hatası":
      return {
        label: status,
        color: "#ff2d55"
      };

    default:
      return {
        label: status,
        color: "#9e9e9e"
      };
  }
};



export const getOrderStatusPropsV2 = (status) => {
  switch (status) {
    case "Ödeme Başarılı":
      return { label: status, color: "success" };
    case "İptal Edildi":
      return { label: status, color: "error" };
    case "Sipariş Alındı":
      return { label: status, color: "primary" };
    case "Kargoya Verildi":
      return { label: status, color: "secondary" };
    case "Ödeme Bekliyor":
      return { label: status, color: "error" };
    case "İşlem Başladı":
      return { label: status, color: "primary" };
    case "İşlem Tamamlandı":
      return { label: status, color: "success" };
    case "İşlem Reddedildi":
      return { label: status, color: "error" };
    case "Ödeme Hatası : Host Bağlantı Hatası":
      return { label: status, color: "error" };

    default:
      return { label: status, color: "secondary" };
  }
};



